<script>
  import { afterUpdate } from 'svelte';
  import JSONTree from 'svelte-json-tree';

  export let obj;
  export let expand = 0;

  let tree;

  afterUpdate(() => {
    if (!tree || expand === 0) return;
    const nodes = tree.children[0].children[0].children[0].children;
    for (var i=0; i<nodes.length;i++) {
      if (nodes[i].classList.contains('arrow')) {
        nodes[i].click();
      }
    }
  });

  const styles = [
    '--json-tree-string-color: #5ecb3f',
    '--json-tree-symbol-color: #cc484a',
    '--json-tree-boolean-color: #8c9add',
    '--json-tree-function-color: #8c9add',
    '--json-tree-number-color: #29cf53',
    '--json-tree-label-color: #bd6ac4',
    '--json-tree-property-color: #ffffff',
    '--json-tree-arrow-color: #ffffff',
    '--json-tree-operator-color: #ffffff',
    '--json-tree-null-color: #ffffff',
    '--json-tree-undefined-color: #ffffff',
    '--json-tree-date-color: #ffffff',
    '--json-tree-internal-color: #ffffff',
    '--json-tree-regex-color: #cb3f41',
    '--json-tree-li-indentation: 1rem',
    '--json-tree-li-line-height: 1.4rem',
    '--json-tree-font-size: 1rem',
    '--json-tree-font-family: "Inter", "Courier New", Courier, monospace',
  ];

  const defaultExpandedPaths = [
    '*',
    '*.*',
    '*.*.*',
    '*.*.*.*',
    '*.*.*.*.*',
    '*.*.*.*.*.*',
    '*.*.*.*.*.*.*',
    '*.*.*.*.*.*.*.*',
    '*.*.*.*.*.*.*.*.*',
    '*.*.*.*.*.*.*.*.*.*',
    '*.*.*.*.*.*.*.*.*.*.*',
    '*.*.*.*.*.*.*.*.*.*.*.*',
  ];
</script>

{#if obj}
  <div bind:this={tree} style={styles.join(';')} class='jtree'>
    <JSONTree value={obj} defaultExpandedLevel={expand} />
  </div>
{/if}

<style>
  div {
    display: inline-block;
    margin-left: 0.05rem;
  }

  :global(span .comma) {
    margin-left: 0 !important;
  }
</style>
